import { useAtomValue, useSetAtom } from "jotai";
import type { TableWidgetCell } from "@/elements/table/tableCell";
import { UnmergeIcon } from "@/icons/widget-menu";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import { applyValue } from "../applyValue";
import { setNewOptions } from "../setNewOptions";

interface UseUnmergeButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function useUnmergeButton({ setActiveSubMenu }: UseUnmergeButtonProps): MenuOptionResult {
    const options = useAtomValue(
        widgetMenuOptionsByNameAtom("unmerge"),
    ) as widgetOption<TableWidgetCell>[];
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const handleClick = () => {
        setActiveSubMenu(null);

        const setNewUnmergeOptions = setNewOptions({ name: "unmerge", setWidgetMenuOptions });
        applyValue({ options, value: options, setNewOptions: setNewUnmergeOptions });
    };

    return {
        content: <UnmergeIcon />,
        handleClick,
    };
}
